/**
 * 出品アイテムステータス
 */
export const BiddingItemStatusConst = {
  /**
   * 未提出
   */
  INPUT: 1,
  /**
   * 提出済
   */
  APPLIED: 2,
  /**
   * 確定済
   */
  CONFIRMED: 3,
  /**
   * 出品取消
   */
  CANCEL: 0,
} as const; // 'as const' が型を固定します (read-only になる)
export type ItemStatusType = typeof BiddingItemStatusConst[keyof typeof BiddingItemStatusConst];